import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

// Dashboard sayfalarının üstündeki standart sticky header.
// Sol: ikon + başlık + (opsiyonel) alt başlık
// Sağ: opsiyonel actions + refresh butonu
//
// Kullanım:
//   <DashboardHeader
//     icon={Users}
//     title="Yönetici Paneli"
//     subtitle="Tüm Departmanlar"
//     onRefresh={loadData}
//     actions={<Badge>...</Badge>}
//   />
export default function DashboardHeader({
  icon: Icon,
  title,
  subtitle,
  onRefresh,
  actions,
  'data-testid': testId,
}) {
  return (
    <header
      className="sticky top-0 z-20 border-b bg-background/95 backdrop-blur-sm"
      data-testid={testId}
    >
      <div className="container mx-auto flex items-center justify-between h-16 px-4 max-w-7xl">
        <div className="flex items-center gap-3">
          {Icon && <Icon className="w-6 h-6 text-primary" />}
          <div>
            <h1 className="text-lg font-bold leading-tight">{title}</h1>
            {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {actions}
          {onRefresh && (
            <Button variant="outline" size="icon" onClick={onRefresh}>
              <RefreshCw className="w-4 h-4" />
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
